var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Text } from '../text';
import { errorStyle } from './styles';
function Error(_a) {
    var id = _a.id, inverted = _a.inverted, size = _a.size, children = _a.children;
    return (_jsx(Text, __assign({ as: "p", id: id, css: errorStyle({ inverted: inverted, size: size }) }, { children: children })));
}
export default Error;
